module.exports = __webpack_public_path__ + "img/philadelphia.aef2a4bc.png";